export default __webpack_public_path__ + "static/media/file_00001 (7).c24b27c7.pdf";